import React from 'react';

import {Create} from 'react-admin';

import CampaignForm, { transform } from "./CampaignForm";

const CampaignCreate = (props) => (
    <Create {...props} transform={transform}><CampaignForm/></Create>
);

export default CampaignCreate;
